export default __webpack_public_path__ + "static/media/under-construction.d7b7f324.png";